export const GATEWAY_TYPE = {
    PAYPAL: 'PAYPAL',
    WIRE_TRANSFER: 'WIRE_TRANSFER'
};

export const INDIVIDUAL_SOLE_PROPRIETOR = 'INDIVIDUAL';
export const SSN = 'SSN';
export const EIN = 'EIN';

export const businessTypeOptions = [
    { label: 'Individual/Sole Proprietor', value: INDIVIDUAL_SOLE_PROPRIETOR }
];

export const PAYMENT_HANDLER = {
    EPIC: 'epic',
    THREE_PARTY: '3-party'
};

export const RELATIONSHIP = {
    PARENT: 'Parent',
    LEGAL_GUARDIAN: 'Legal_Guardian'
};

export const GUARDIAN_INFO_KEYMAPS = ['guardianFirstName', 'guardianLastName', 'guardianSignature', 'relationship'];

export const ACCOUNT_STATUS = {
    PENDING_ACCOUNT_ACTIVATION: 'ACCOUNT_PENDING_ACTIVATION',
    PENDING_TRANSFER_METHOD_ACTION: 'ACCOUNT_PENDING_TRANSFER_METHOD',
    ACCOUNT_PENDING_VERIFICATION: 'ACCOUNT_PENDING_VERIFICATION'
};
